import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import usersService from "../../Services/users.service";
import { alertSnackbarError, alertSnackbarSuccess } from "./alertStatusSlice";

const initialState = {
  loading: false,
  result: [],
};
export const list = createAsyncThunk("users/list", async (values, thunkAPI) => {
  try {
    const result = await usersService.list(values).then((respone) => {
      const { data } = respone;
      return data.result;
    });
    return result;
  } catch (error) {
    errorSlice.error(error, thunkAPI);
  }
});

export const usersCreate = createAsyncThunk(
  "users/create",
  async (values, thunkAPI) => {
    try {
      const result = await usersService.create(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const usersUpdate = createAsyncThunk(
  "users/update",
  async (values, thunkAPI) => {
    try {
      const result = await usersService.update(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const usersDelete = createAsyncThunk(
  "users/delete",
  async (values, thunkAPI) => {
    try {
      const result = await usersService.destroy(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const usersSlice = createSlice({
  name: "usersSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(list.pending, (state, action) => {
      state.loading = true;
      state.result = [];
    });
    builder.addCase(list.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(list.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
    });
  },
});

export const { reducer } = usersSlice.actions;

export default usersSlice.reducer;
